<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>{{ $route.meta.name }}管理</el-breadcrumb-item>
      <el-breadcrumb-item>{{ $route.meta.name }}列表</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="row">
      <div class="col-sm-12">
        <div class="panel">
          <div class="panel-heading">
            <div class="panel-control">
              <el-date-picker
                v-model="selectedPeriod"
                :type="inventoryCategory == 1 ? 'month' : 'year'"
                :placeholder="inventoryCategory == 1 ? '选择月' : '选择年'"
                :key="inventoryCategory == 1 ? 'month' : 'year'"
                size="small"
                class="mr-20"
                @change="periodChange"
              >
              </el-date-picker>

              <el-radio-group
                v-model="inventoryCategory"
                @change="reset"
                size="small"
              >
                <el-radio-button :label="1">月度盘点</el-radio-button>
                <el-radio-button :label="2">年度盘点</el-radio-button>
              </el-radio-group>
            </div>

            <h3 class="panel-title">{{ period }}复合片盘点列表</h3>
          </div>

          <div>
            <item-table :items="items.list" v-loading="loading"></item-table>
            <pagination
              :records="items.count"
              :page="page"
              :per-page="size"
              @paginate="loadData"
            ></pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { pdcInventoryList } from '@/service/getData'
import ItemTable from './table'

export default {
  components: {
    ItemTable,
  },
  data() {
    return {
      loading: false,
      inventoryCategory: 1,
      period: '',
      selectedPeriod: new Date(),
      page: 1,
      size: 20,
      items: {
        list: [],
        count: 0,
      },
    }
  },
  created() {
    this.getData()
  },
  methods: {
    reset() {
      this.selectedPeriod = new Date()
      this.page = 1
      this.getData()
    },
    periodChange() {
      this.page = 1
      this.getData()
    },
    async getData() {
      let data = {
        page: this.page - 1,
        size: this.size,
        category: this.inventoryCategory,
        period:
          this.inventoryCategory == 1
            ? this.$time(this.selectedPeriod).format('YYYY-MM-DD')
            : this.$time(this.selectedPeriod).format('YYYY-MM-DD'),
      }
      this.loading = true
      let res = await pdcInventoryList(data)

      if (res.status != 0) return false
      this.items = res.data
      this.period = res.data.period
      this.loading = false
    },
    async loadData(page) {
      this.page = page
      this.getData()
    },
  },
}
</script>